import { connect } from 'react-redux';
import { instantQuoteSelector } from '../../../../../redux/instant-quote/instant-quote.selectors';
import { instantQuoteDispatcher } from '../../../../../redux/instant-quote/instant-quote.dispatchers';
import { InstantQuoteFormComponent } from './instant-quote-form';
export const InstantQuoteForm = connect(instantQuoteSelector, instantQuoteDispatcher)(InstantQuoteFormComponent);